export default __webpack_public_path__ + "static/media/resume_tw.71fcccb2.pdf";